import React, {
  useState,
  useEffect
} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  colors,
  Typography,
} from '@material-ui/core';

import {ProfileChip} from './ProfileChip';
import {DateTimeView} from './DateTimeView';
import localization from '../../../utils/localizations';
import {
  Comment
} from '../../../types';


const useStyles = makeStyles((theme) => ({
  root: {
    padding: 10,
  },
  metaContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  marginRight: {
    marginRight: 10,
  },
  comment: {
    whiteSpace: 'pre-wrap',
  },
  commentContainer: {
    marginBottom: 10,
  },
  inlineBlock: {
    display: 'inline-block',
  }
}));


function UserComment(props: {
  comment: Comment;
  className?: string;
  inline?: boolean;
  hideUser?: boolean;
}) {
  const classes = useStyles();
  return (
    <Paper className={`${classes.root} ${props.className} ${props.inline ? classes.inlineBlock : ''}`}>
      <div className={classes.commentContainer}>
        <Typography className={classes.comment}>{props.comment.comment}</Typography>
      </div>
      <div className={classes.metaContainer}>
        {(!props.hideUser && props.comment.user) && <ProfileChip profile={props.comment.user} size="small" className={classes.marginRight} />}
        <DateTimeView
          value={props.comment.created_at}
          fromNow
          chip
          size="small"
        />
      </div>
    </Paper>
  );
}

export {UserComment};